import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { AxiosError } from 'axios';
import { POST_URL } from '@utils/api/endpoints.ts';
import { useMutation, useQueryClient } from 'react-query';

export interface DocumentPayload {
  filename: string;
  target_document_id: string;
  target_session_id: string;
  session_documents: {
    document_id: string;
    session_id: string;
  }[];
}

async function postDocument(
  payload: DocumentPayload
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<BaseResponse<any>> {
  const url = `${POST_URL().mergeDocuments}`;
  const { data } = await Axios.post(url, payload);
  return data;
}

export function useMergeDocuments() {
  const queryClient = useQueryClient();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useMutation<BaseResponse<any>, AxiosError<BaseError>, DocumentPayload>(
    async (payload: DocumentPayload) => postDocument(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['folders'],
          exact: false
        });
      }
    }
  );
}
